class CouldNotGetPromotickToken extends Error {
    constructor(cause: Error) {
        super("No se pudo obtener el token de promotick");
        this.name = "CouldNotGetPromotickToken";
        this.cause = cause;
    }
}

export { CouldNotGetPromotickToken };
